/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { DatePicker, Dialog, Dropdown, Form, requiredItem, MessageBar, Language, } from '@eta/components';
import { Icon, IDropdownOption, Label, PrimaryButton, MessageBarType, } from '@fluentui/react';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isNullOrUndefined } from 'util';
import { connect, ConnectedProps } from 'react-redux';
import { UIHelpers } from '../../helpers/UIHelpers';
import { AddressDto, ClaimLookupDto, GetIntermediaryExternalResponseDto, GetRepresentationDetailsExternalResponseDto, IntermediaryDto, IntermediaryRepresentationDto, IntermediaryRepresentationsRequestDto, IntermediaryStatuses, LookupsDto } from '../Service/proxy';
import { ServiceCreator } from '../Service/client';
import { ReduxState } from '../../common/reducers';
import PermessionItem from './PermessionItem';
import {ErrorNotFondPermession} from './ErrorNotFondPermession';
import { WizardState, Wizard, WizardPivotPanel, WizardPivotHeader, useWizard } from '../../common/component/WizardPivot';
import './ManageIntermediary.scss';


export class CustomLookupsDto {
    id?: number;

    code?: string;

    name?: string;

    description!: string | undefined;

    parentCode?: string;

    checked?: boolean;

    disabled?: boolean;

    hidden?: boolean;

}
export enum Permessions {
    CanViewDocument = 'ViewDoc',
    CanSubmitDocument = 'SubmitDoc',
    CanCancelDocument = 'CancelDoc',
    CanRejectDocument = 'RejectDoc',
    CanExportDocument = 'ExportDoc',
    CanDeclineCancellation = 'DecCancelDoc',
    CanDeclineRejection = 'DecRejectDoc',
    CanViewNotifications = 'ViewNotification',
    CanManageTaxpayerCodes = 'MngCodes'
}
const mapStateToProps = (state: ReduxState) => ({
    currentLanguage: state.reduxlanguage.language,
});


const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;
export interface Props {
    hidden: boolean;
    onClose: () => void;
    onSave: () => void;
    isEdit?: boolean;
    RepresentationId?: number;
}

const ManageIntermediary: FC<PropsFromRedux & Props> = (props: PropsFromRedux & Props) => {
    const { RepresentationId, isEdit, currentLanguage: propsCurrentLanguage, hidden, onClose, onSave } = props;
    const today: Date = new Date(Date.now());
    const minDate: Date = today;
    const { t } = useTranslation(['resources', 'common']);
    const [RepresentationObj, setRepresentationObj] = useState<GetRepresentationDetailsExternalResponseDto | undefined>();
    const [IntermediaryKey, setIntermediaryKey] = useState<string | number | undefined>(undefined);
    const [RepresentationFrom, setRepresentationFrom] = useState<Date | undefined>(minDate);
    const [RepresentationTo, setRepresentationTo] = useState<Date>();
    const [showErrorPermessionDialog, setshowErrorPermessionDialog] = useState<boolean>(false);
    const [ViewDocEnabled, setViewDocEnabled] = useState<boolean>(false);

    const [claimsArray, setClaimsArray] = useState<CustomLookupsDto[]>([]);
    const [claimsCategory,setClaimsCategory] = useState<LookupsDto[]>([]);
    const [claims,setClaims] = useState<ClaimLookupDto[]>([]);
    const [IntermediaryDropDown, setIntermediaryDropDown] = useState<IDropdownOption[]>();
    const [AllIntermediary, setAllIntermediary] = useState<GetIntermediaryExternalResponseDto | undefined>(undefined);
    const [IntermediaryDetials, setIntermediaryDetials] = useState<IntermediaryDto | undefined>();
    const [error, setError] = useState<string>();
    const [loadText, setLoadText] = useState<string>();
    const [currentModuleLanguage, setCurrentModuleLanguage] = useState<Language>();
    const form = useRef(new Form({}));
    const [, setIsFormValid] = useState<boolean>(form.current.isValid);
    form.current.onValidityChanged = (isValid) => setIsFormValid(isValid);
    const [PermessionsArray] = useState(Object.values(Permessions)
        // eslint-disable-next-line no-restricted-globals
        .filter(x => isNaN(Number(x))));
        const ActiveToErr = 'ActiveIntermediaryTaxpayerRepresentation[0].ActiveTo';
        const ActiveFromErr = 'ActiveIntermediaryTaxpayerRepresentation[0].ActiveFrom';
        const RepresentationIdNotFoundErr = 'RepresentationIdNotFound';
        const TaxpayerIdNotFoundErr = 'TaxpayerIdNotFound';
        const RepresentationOverlappingDBErr = 'RepresentationOverlappingDB';
        const RepresentationOverlappingReqErr = 'RepresentationOverlappingReq';
        const TaxpayerRepresentationPeriodErr = 'TaxpayerRepresentationPeriod';
        const TaxpayerRepresentationIdErr = 'TaxpayerRepresentationId';
        const NotExistedTaxpayerIdErr = 'NotExistedTaxpayerId';
        const TaxPayerIdErr= 'TaxPayerId';
        const InvalidPermissionErr= 'InvalidPermission';

        const IsViewDoc=(item: ClaimLookupDto): boolean=>{
            return (item.id===1|| item.code===Permessions.CanViewDocument) || item.alwaysEnabled===true;
        };
    const MapFromOriginalToCustom = (claimsOriginal: ClaimLookupDto[]): CustomLookupsDto[] => {
        const res: CustomLookupsDto[] = [];

        claimsOriginal.forEach(item => {
            const CustomItem: CustomLookupsDto = new CustomLookupsDto();
            CustomItem.id = item.id;
            CustomItem.checked = IsViewDoc(item);
            CustomItem.code = item.code;
            CustomItem.name = item.name;
            CustomItem.parentCode = item.parentCode;
            CustomItem.description = item.description;
            CustomItem.disabled = IsViewDoc(item)?true: !item.enabled;
            CustomItem.hidden = IsViewDoc(item)?false: !item.enabled;

            res.push(CustomItem);
        });

        return res.sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    };
    const MapFromRepresentationToCustom = (claimsOriginal: ClaimLookupDto[], RepresentationDetails: GetRepresentationDetailsExternalResponseDto): CustomLookupsDto[] => {
        const res: CustomLookupsDto[] = [];
        claimsOriginal.forEach(item => {
            const CustomItem: CustomLookupsDto = new CustomLookupsDto();
            CustomItem.id = item.id;
            CustomItem.code = item.code;
            CustomItem.name = item.name;
            CustomItem.parentCode = item.parentCode;
            CustomItem.description = item.description;
            CustomItem.disabled = IsViewDoc(item)?true: !item.enabled;
            CustomItem.hidden = IsViewDoc(item)?false: !item.enabled;

            switch (item.code) {
                case Permessions.CanCancelDocument:
                    CustomItem.checked = RepresentationDetails.canCancelDocument ?? false;
                    break;
                case Permessions.CanDeclineCancellation:
                    CustomItem.checked = RepresentationDetails.canDeclineCancellation ?? false;
                    break;
                case Permessions.CanDeclineRejection:
                    CustomItem.checked = RepresentationDetails.canDeclineRejection ?? false;
                    break;
                case Permessions.CanExportDocument:
                    CustomItem.checked = RepresentationDetails.canExportDocument ?? false;
                    break;
                case Permessions.CanManageTaxpayerCodes:
                    CustomItem.checked = RepresentationDetails.canManageTaxpayerCodes ?? false;
                    break;
                case Permessions.CanRejectDocument:
                    CustomItem.checked = RepresentationDetails.canRejectDocument ?? false;
                    break;
                case Permessions.CanSubmitDocument:
                    CustomItem.checked = RepresentationDetails.canSubmitDocument ?? false;
                    break;
                
                case Permessions.CanViewNotifications:
                    CustomItem.checked = RepresentationDetails.canViewNotifications ?? false;
                    break;

                default:
                    CustomItem.checked = CustomItem.id === 1|| CustomItem.code===Permessions.CanViewDocument;
                    break;
            }
            res.push(CustomItem);
        });
        return res.sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    };
    const MapFromRepresentation = (RepresentationDetails: GetRepresentationDetailsExternalResponseDto | undefined): IntermediaryDto | undefined => {
        const filter = AllIntermediary?.approvedIntermediaries?.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e: any) => e.taxpayerId === RepresentationDetails?.taxpayerId
        );
        setIntermediaryKey(filter?.id);

        setIntermediaryDetials(filter);

        setRepresentationFrom(RepresentationDetails?.representationFrom);
        setRepresentationTo(RepresentationDetails?.representationTo);

        return filter;
    };
    const ResetCliams = () => {
        const res: CustomLookupsDto[] = [];

        // eslint-disable-next-line no-unused-expressions
        claims?.forEach(item => {
            const CustomItem: CustomLookupsDto = new CustomLookupsDto();
            CustomItem.id = item.id;
            CustomItem.checked =IsViewDoc(item); 
            CustomItem.code = item.code;
            CustomItem.name = item.name;
            CustomItem.parentCode = item.parentCode;
            CustomItem.description = item.description;
            CustomItem.disabled = IsViewDoc(item)?true: !item.enabled;
            CustomItem.hidden = IsViewDoc(item)?false: !item.enabled;

            res.push(CustomItem);
        });
        setClaimsArray(res.sort((a, b) => (a.id ?? 0) - (b.id ?? 0)));
    };
    const onChange = (key?: string | number | undefined) => {
        setIntermediaryKey(key);
        const filter = AllIntermediary?.approvedIntermediaries?.find(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (e: any) => e.id === key
        );
        setIntermediaryDetials(filter);
        const date = (filter?.activeFrom ?? today) <
            today
            ? today
            : filter?.activeFrom;
        setRepresentationFrom(date);
        setRepresentationTo(date);
    };
    const SetPermession = (itemId: string, CheckValue: boolean) => {
        const originalItem = claimsArray.find(x => x.id === Number(itemId));
        if (originalItem) {
            const newItem = originalItem;
            newItem.checked = CheckValue;
            const index = claimsArray.indexOf(originalItem);
            const newItems = claimsArray.slice();
            newItems[index] = { ...originalItem, ...newItem };
            setClaimsArray([...newItems]);
        }

    };
    const GetPermession = (itemId: string): boolean => {
        const CurrentItem = claimsArray.find(x => x.id === Number(itemId));
        return CurrentItem?.checked ?? false;

    };
    function GetTextContent(item: CustomLookupsDto) {
        const category = claimsCategory?.find(x => (x.id ?? 0) === Number(item.parentCode ?? 0));
        return (
            <>
                <b className='bold'>{category?.name ?? ''}</b> <span>{' - '}</span><span>{item?.name ?? ''}</span>
            </>
        );
    };
    const getIntermediaries = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const intermediariesList = await client.getIntermediaries();
        const options = intermediariesList.approvedIntermediaries?.filter((e) =>
            (e.activeTo || today) >= today && e.status !== IntermediaryStatuses.Blocked).map((v: any) => {
                return { key: v.id || 0, text: v.namePrimaryLang || v.nameSecondaryLang || '' };
            }) ?? [];
        setIntermediaryDropDown(options);
        setAllIntermediary(intermediariesList);
        return intermediariesList;
    };
    const getConfigs = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const Config = await client.getConfig();
        setClaimsCategory(Config.claimsCategory??[]);
        setClaims(Config.claims??[]);
       const DocEnabled= Config.claims?.find(x=>x.code===Permessions.CanViewDocument)?.enabled;
       setViewDocEnabled(DocEnabled??false);
       if(!DocEnabled)
       setshowErrorPermessionDialog(true);
       else
       setshowErrorPermessionDialog(false);

    };
    const getRepresntationDetails = async () => {
        const client = ServiceCreator.getProviderManagementPublicClient();
        const RepresntationDetails = await client.getRepresentationDetails(RepresentationId ?? 0);
        setRepresentationObj(RepresntationDetails);
    };

    const GetAddress=(address: AddressDto|undefined ): string=>{
        if(!address)return '';
        return `${address.buildingNo},${address.streetName},${address.flatNo},${address.floorNo},${address.cityID},${address.countryID},${address.governorateID}`;
    };
    useEffect(() => {
        if (isEdit && RepresentationObj === undefined && (RepresentationId ?? 0) > 0) {
            getRepresntationDetails();
        }
    }, [RepresentationObj, isEdit, RepresentationId]);
    useEffect(() => {
        if ((!isEdit &&( !claimsCategory&&!claims)) || currentModuleLanguage?.lang !== propsCurrentLanguage.lang) {
            setCurrentModuleLanguage(propsCurrentLanguage);
            getConfigs();

        }
    }, [propsCurrentLanguage, currentModuleLanguage, claims,claimsCategory, getConfigs,isEdit]);



    useEffect(() => {
        if ((claims?.length ?? 0) > 0 && claimsArray.length === 0) {

            if (!isEdit)
                setClaimsArray(MapFromOriginalToCustom(claims ?? []));
            else if (isEdit && RepresentationObj)
                setClaimsArray(MapFromRepresentationToCustom(claims ?? [], RepresentationObj));
        }
    }, [claims, claimsArray, isEdit, RepresentationObj]);

    useEffect(() => {
        if (isEdit && RepresentationObj && (AllIntermediary?.approvedIntermediaries?.length ?? 0) > 0) {
            setIntermediaryDetials(MapFromRepresentation(RepresentationObj));
        }
    }, [RepresentationObj, isEdit, AllIntermediary]);

    useEffect(() => {
        if (!hidden) {
            getIntermediaries();
        }
    }, [hidden]);

    const addIntermediary = async () => {
        try {
            setLoadText(t('common:Searching'));
            const dto = new IntermediaryRepresentationDto();
            dto.representationId = isEdit ? RepresentationObj?.id : 0;            
            dto.activeFrom = UIHelpers.getUTCStartDate( RepresentationFrom);
            dto.activeTo = UIHelpers.getUTCEndDate( RepresentationTo) ?? undefined;
            dto.taxpayerId = IntermediaryDetials?.taxpayerId ?? 0;
            dto.canViewDocument = claimsArray.find(x => x.code === Permessions.CanViewDocument)?.checked ?? true;
            dto.canCancelDocument = claimsArray.find(x => x.code === Permessions.CanCancelDocument)?.checked ?? false;
            dto.canDeclineCancellation = claimsArray.find(x => x.code === Permessions.CanDeclineCancellation)?.checked ?? false;
            dto.canDeclineRejection = claimsArray.find(x => x.code === Permessions.CanDeclineRejection)?.checked ?? false;
            dto.canExportDocument = claimsArray.find(x => x.code === Permessions.CanExportDocument)?.checked ?? false;
            dto.canManageTaxpayerCodes = claimsArray.find(x => x.code === Permessions.CanManageTaxpayerCodes)?.checked ?? false;
            dto.canRejectDocument = claimsArray.find(x => x.code === Permessions.CanRejectDocument)?.checked ?? false;
            dto.canSubmitDocument = claimsArray.find(x => x.code === Permessions.CanSubmitDocument)?.checked ?? false;
            dto.canViewNotifications = claimsArray.find(x => x.code === Permessions.CanViewNotifications)?.checked ?? false;

            const client = ServiceCreator.getProviderManagementPublicClient();
            const arr: IntermediaryRepresentationDto[] = [];
            arr[0] = dto;
            const request = new IntermediaryRepresentationsRequestDto();
            request.activeIntermediaryTaxpayerRepresentation = arr;
            await client.saveTaxpayerIntermediaries(request);
            onSave();
        } catch (ex) {
            const Err=UIHelpers.GetErrorsMessages(ex);
            const ErrMsg=Err[ActiveToErr]??
                         Err[ActiveFromErr]??
                         Err[RepresentationIdNotFoundErr]??
                         Err[TaxpayerIdNotFoundErr]??
                         Err[RepresentationOverlappingDBErr]??
                         Err[RepresentationOverlappingReqErr]??
                         Err[TaxpayerRepresentationPeriodErr]??
                         Err[TaxpayerRepresentationIdErr]??
                         Err[NotExistedTaxpayerIdErr]??
                         Err[TaxPayerIdErr]??
                         Err[InvalidPermissionErr]??
                         Err?.BusinessErrors??
                         Err?.ExceptionMessage??'';
                   setError(ErrMsg);
        }
        setLoadText('');
    };
    const getWizardState = (): WizardState => {
        return (
            {
                translationNamespace: 'Permessions',
                tabs: [
                    {
                        itemKey: 'IntermediaryInfo',
                        label: t('IntermediaryInfo'),
                    },
                    {
                        itemKey: 'Representation',
                        label: t('Representation'),
                    }
                ],
                selectedTabKey: 'IntermediaryInfo',
                showTabState: true,
                canGoBack: false,
                canGoNext: true,
            }
        );
    };

    const PremessionWizardState = useWizard(getWizardState());
    const onContinueClick = () => {
        PremessionWizardState.nextTab();
    };
    useEffect(() => {
        if (
            PremessionWizardState?.state.selectedTabKey ==='Representation') {
                PremessionWizardState.ChangeTabState('IntermediaryInfo',IntermediaryKey?'completed':'error');
                PremessionWizardState.ChangeTabState('Representation',IntermediaryKey?'completed':'none');

        }
    }, [ PremessionWizardState?.state.selectedTabKey,IntermediaryKey]);
    return (
        <>
       
        {
(showErrorPermessionDialog&&!ViewDocEnabled) ?(
    <ErrorNotFondPermession 
    hidden={hidden}
    onClose={() => {onClose();setshowErrorPermessionDialog(false);}}
    />
):(
<>
    {((claims.length??0)>0 &&ViewDocEnabled)&&(
    <Dialog
    containerClassName="ManageIntermediary"
    hidden={hidden}
    onDismiss={() => {
        onClose();
    }}
    loadingText={loadText}
    maxWidth={750}
    title={isEdit ? (
        <>
            {t('form.Taxpayer.EditIntermediary')}
        </>
    ) : (
        <>
            <Icon iconName="Add" /> {t('form.Taxpayer.AddIntermediary')}
        </>
    )


    }
>
    <div className="intermediary">
        {error && (
            <MessageBar
                messageBarType={MessageBarType.error}
                isMultiline={false}
                className="messageBar"
            >
                {error}
            </MessageBar>
        )}

        <Wizard state={PremessionWizardState}>
            <WizardPivotHeader />

            <div className='content'>
                <WizardPivotPanel panelKey="IntermediaryInfo">
                    <div>
                        {!isEdit ? (
                            <Dropdown
                                className="intermediaryDDL"
                                options={IntermediaryDropDown ?? []}
                                label={t('form-components.Intermediary')}
                                selectedKey={IntermediaryKey}
                                onChange={(_, option) => {
                                    onChange(option?.key);
                                }}
                                validationFunc={(v: any) =>
                                    requiredItem(
                                        t,
                                        v,
                                        t('form-components.Intermediary')
                                    )
                                }
                                onValidationChange={(isValid: any) =>
                                    form.current.SetValidity(
                                        'IntermediaryKey',
                                        isValid
                                    )
                                }
                            />
                        ) : (
                            <div
                                className={
                                    isNullOrUndefined(IntermediaryKey)
                                        ? 'bodyLine c-grid opacity'
                                        : 'bodyLine c-grid'
                                }
                            >
                                <Label>{t('form-components.Intermediary')}</Label>
                                <Label className='namePrimary'>
                                    {UIHelpers.getLocalizedName(IntermediaryDetials?.namePrimaryLang, IntermediaryDetials?.nameSecondaryLang, propsCurrentLanguage)}
                                </Label>
                            </div>
                        )}
                    </div>
                    <div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('id')}</Label>
                            <Label>
                                {IntermediaryDetials?.taxpayerRIN}
                            </Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('email')}</Label>
                            <Label>{IntermediaryDetials?.email}</Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('PhoneNumber')}</Label>
                            <Label>{IntermediaryDetials?.mobileNo}</Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('URL')}</Label>
                            <a
                                className="url"
                                // eslint-disable-next-line react/jsx-no-target-blank
                                target="_blank"
                                rel="noreferrer"
                                href={IntermediaryDetials?.url}
                            >
                                {IntermediaryDetials?.url}
                            </a>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('PostalAddress')}</Label>
                            <Label>{GetAddress(IntermediaryDetials?.address)}</Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('Activefrom')}</Label>
                            <Label>
                                {UIHelpers.getLocalizedDateTime(
                                    'Date',
                                    IntermediaryDetials?.activeFrom
                                )}
                            </Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                            <Label>{t('Activeto')}</Label>
                            <Label>
                                {UIHelpers.getLocalizedDateTime(
                                    'Date',
                                    IntermediaryDetials?.activeTo
                                )}
                            </Label>
                        </div>
                        <hr />
                        <div
                            className={
                                isNullOrUndefined(IntermediaryKey)
                                    ? 'bodyLine c-grid opacity'
                                    : 'bodyLine c-grid'
                            }
                        >
                             <Label>{t('resources:IntermediaryStatus')}</Label>
                                                <Label>
                                                {isNullOrUndefined(IntermediaryKey)?(<></>):(

                                                    <div>
                                                        <span className={IntermediaryDetials?.status === IntermediaryStatuses.Unblocked ? 'green' : 'red'}>
                                                            {IntermediaryDetials?.status === IntermediaryStatuses.Unblocked
                                                                ? t('LinkedTaxpayer.status-allowed')
                                                                : t('LinkedTaxpayer.status-notAllowed')}
                                                        </span>
                                                    </div>
                                                )}
                                                 </Label>
                          
                        </div>
                    </div>


                </WizardPivotPanel>
                <WizardPivotPanel panelKey="Representation">
                    <div className='Representation'>
                        <div className="bodyLine">
                            <div className='innerDatePicker'>
                                <DatePicker
                                    label={t('form-components.Representationfrom')}
                                    value={RepresentationFrom}
                                    onSelectDate={(date) =>
                                        setRepresentationFrom(date ?? undefined)
                                    }
                                    className="Representationfrom"
                                    isRequired
                                    minDate={
                                        (IntermediaryDetials?.activeFrom ?? today) <
                                            today
                                            ? today
                                            : IntermediaryDetials?.activeFrom
                                    }
                                    disabled={isNullOrUndefined(IntermediaryKey)}
                                    firstWeekOfYear={1}
                                    showMonthPickerAsOverlay
                                    formatDate={UIHelpers.FormatDatePickerValue}
                                    parseDateFromString={
                                        UIHelpers.ParseDatePickerString
                                    }
                                />
                            </div>
                            <div className='innerDatePicker'>
                                <DatePicker
                                    label={t('form-components.Representationto')}
                                    value={RepresentationTo}
                                    onSelectDate={(date) =>
                                        setRepresentationTo(date ?? undefined)
                                    }
                                    className="Representationto"
                                    firstWeekOfYear={1}
                                    showMonthPickerAsOverlay
                                    minDate={today}
                                    maxDate={IntermediaryDetials?.activeTo}
                                    disabled={isNullOrUndefined(IntermediaryKey)}
                                    formatDate={UIHelpers.FormatDatePickerValue}
                                    parseDateFromString={
                                        UIHelpers.ParseDatePickerString
                                    }
                                />
                            </div>
                        </div>
                        <div className='contentRepresentation'>
                            <div className='titlePermissions'>
                                <Label>
                                    {t(
                                        'Intermediary.RepresentationPermissions'
                                    )}
                                </Label>
                            </div>
                            <hr />
                            <div>
                                {claimsArray?.map((item) => {
                                    const intermediaryClaim = PermessionsArray.find(x => x === item.code);
                                    if (!intermediaryClaim) return (<></>);
                                    return (
                                        <>
                                        {(item.hidden)?(<></>):(
                                        <div className='PermessionItem'>
                                            <div>
                                                <PermessionItem
                                                    id={item?.id?.toString() ?? ''}
                                                    noteContent={item?.description?.toString() ?? ''}
                                                    textConent={GetTextContent(item)}
                                                    onChangeEvent={(c, id) => { SetPermession(id, c); }}
                                                    checked={GetPermession(item?.id?.toString() ?? '')}
                                                    disabled={item.disabled}
                                                />
                                            </div>
                                            <hr />
                                        </div>
                                        )}
                                        </>
                                    );
                                })}
                                <div className='resetLink'>
                                    <a href='#' onClick={() => ResetCliams()}>{t('ResetToDefualt')}</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </WizardPivotPanel>
                {(!RepresentationObj?.canViewDocument && isEdit ) && (
                    <MessageBar className="warning-intermediary" messageBarType={MessageBarType.warning}>
                       {t('warningSaveMessage')}
                     </MessageBar>
                     
                  )}
            </div>
            <div className='footer'>
                <div className="navigation">
                    {(!isEdit && PremessionWizardState.state.canGoBack)&& (
                        <PrimaryButton
                            className='previous'
                            iconProps={propsCurrentLanguage.isRtl ? { iconName: 'Forward' } : { iconName: 'Back' }}
                            disabled={
                                !PremessionWizardState.state.canGoBack
                            }
                            text={t('previous')}
                            onClick={() =>
                                PremessionWizardState.previousTab()
                            }
                        />
                    )}
                    {(PremessionWizardState.state.canGoNext && !isEdit) ? (
                        <PrimaryButton
                            className='continue'
                            menuIconProps={propsCurrentLanguage.isRtl ? { iconName: 'Back' } : { iconName: 'Forward' }}
                            disabled={
                                !PremessionWizardState.state.canGoNext
                            }
                            text={t('continue')}
                            onClick={() => onContinueClick()}
                        />
                    ) : (
                        <>
                            {isEdit && (
                                <PrimaryButton
                                    className='cancel'
                                    text={t('Cancel')}
                                    onClick={() => onClose()}

                                />
                            )}
                            <PrimaryButton
                                className='save'
                                menuIconProps={!isEdit ? { iconName: 'Add' } : { iconName: 'Save' }}
                                disabled={
                                    (!isEdit && PremessionWizardState.state.canGoNext) || isNullOrUndefined(IntermediaryKey)
                                }
                                text={isEdit ? t('Save') : t('AddIntermediary')}
                                onClick={() => addIntermediary()}

                            />
                        </>
                    )}
                </div>
            </div>
        </Wizard>
    </div>
</Dialog>
) }
</>
)}
        </>
    );
};

export default connector(ManageIntermediary);
